<template>
    <main id="home-wrapper">
        <div id="detail_photo">
            <breadcrumb
                :breadcrumb="[
                    { title: 'Community', url: app_url+'/', status: false },
                    { title: 'Gallery Video', url: app_url+'/gallery-video', status: true },
                    { title: detailVideo
                        ? detailVideo.title.length > 20
                            ? detailVideo.title.substr(0, 20) + ' ...'
                            : detailVideo.title
                        : 'N/A', url: ' ', status: true }
                ]"
            ></breadcrumb>

            <section id="detail-article" class="section withPad">
                <div class="container">
                    <div class="row-detail-article">
                    <div class="inner_detail_article" >
                        <div class="main-title-article">
                            <h3>{{ detailVideo.title }}</h3>
                            <span class="date-article">{{ detailVideo.date }}</span>
                        </div>
                        <div class="video_article" v-html="detailVideo.embed">
                        </div>
                        <div class="text_article">
                          <span v-html="detailVideo.description"></span>
                        </div>
                    </div><!--.inner_detail_article api-->
                    </div>
                </div>
            </section>

            <section id="related-article" class="section withPad">
                <div class="container">
                    <div class="section_title">
                        <h3>Related Video</h3>
                    </div>
                    <div class="list_article">
                        <RelatedVideo
                            url="/gallery-video"
                            :relatedData="relatedVideo"
                            @getRelatedData="getRelatedVideo">
                        </RelatedVideo>
                    </div>
                </div>

            </section>

        </div>
    </main>
</template>

<script>
import RelatedVideo from "../news/RelatedVideo";
import BreadCrumb from "../../widget/BreadCrumb";
import { isMobile } from "mobile-device-detect";
import { Carousel, Slide } from "vue-carousel";

export default {
    components: {
        Carousel,
        Slide,
        breadcrumb: BreadCrumb,
        RelatedVideo
    },
    data() {
        return {
            base_url:base_url,
            app_url:app_url,
            api_url:api_url,
            mobile: false,
            detailVideo: null,
            relatedVideo: null,
            currentPage: 1,
        };
    },
    created() {
        this.mobile = isMobile;
        this.getDetailVideo();
    },
    methods: {
      getDetailVideo() {
          let route = api_url+`/video-detail?slug=${this.$route.query.slug}`;
          axios
              .get(route)
              .then(res => {
                  console.log(res);
                  if (res.status == 200) {
                      if (res?.data?.status) {
                          this.detailVideo = res?.data?.data?.detailVideo;
                          if (this.detailVideo) {
                              this.getRelatedVideo();
                          }
                      }
                  }
              })
              .catch(err => {
                  console.log(err);
              });
      },
      getRelatedVideo() {
          let route = api_url+`/video-related?tag=${this.detailVideo.tag}&except=${this.detailVideo.id}`;
          if (this.relatedVideo?.nextPageUrl) {
              route = this.relatedVideo?.nextPageUrl;
          }
          axios
              .get(route)
              .then(res => {
                  console.log(res);
                  if (res.status == 200) {
                      if (res?.data?.status) {
                          this.relatedVideo = res?.data?.data;
                      }
                  }
              })
              .catch(err => {
                  console.log(err);
              });
      }
    }
};
</script>

<style scoped lang="scss">
.main-title-article{
    display:block;
    margin:20px 0;
    h3{
        font-weight: bold;
        font-size: 32px;
        color: #FFFFFF;
        margin:0 0 0px 0;
    }
    .date-article{
        font-weight: 600;
        font-size: 12px;
        color: #B4B4B4;
    }
}
.slider_article,.text_article{
    display:block;
    width:100%;
    margin-bottom:50px;
}
.thumb_main_article{
    display:block;
    overflow:hidden;
    border-radius: 10px;
    img{
        object-fit:cover;
        width:100%;
        height:100%;
    }
}
.video_article{
//   position: relative;
//   padding-bottom: 56.25%; /* 16:9 */
//   height: 0;
text-align: center;
  margin-bottom:20px;
}
.video_article iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

@media all and (max-width:767px){
  .main-title-article h3{
    font-size:24px;
  }
}
</style>
